import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular';



@IonicPage()
@Component({
  selector: 'page-testmodal',
  templateUrl: 'testmodal.html',
})
export class TestmodalPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TestmodalPage');
  }


changeIt(){
  console.log('Testmodal changeIt()');
}

close(){
this.viewCtrl.dismiss();
}

}



// WEBPACK FOOTER //
// ./src/pages/modalpages/testmodal/testmodal.ts